import React from 'react';
import { connect } from 'react-redux';
import { bindActionCreators } from 'redux';
import moment from 'moment-timezone';
import { FormattedMessage } from 'react-intl';
import messages from '../../../../text/messages';
import Tabs from '../../../../components/tabs';
import { getJobs } from '../../../../reducers/jobs';
import { createTimesheet, findTimesheets } from '../../../../reducers/timekeeping';
import { getWeekRange, isSameDay } from '../../../../utilities/dateTime';
import { TIMESHEET_STATUS } from '../../../../text/enumerations';
import WorkWeek from '../../components/workWeek';
import TimesheetsList from '../../lists/timesheets';
import { history } from '../../../../configuration/store';
import NoDataCard from '../../../../components/noDataCard';

class ContractorTimeKeeping extends React.Component {
    constructor(props) {
        super(props);
        this.state = { date: undefined, pendingTimesheetExists: false };

        this.initialize = this.initialize.bind(this);

        this.renderContactSupportError = this.renderContactSupportError.bind(this);
        this.getTabs = this.getTabs.bind(this);
    }

    initialize() {
        const { role, getJobs, findTimesheets, createTimesheet } = this.props;
        getJobs(role, jobs => {
            const job = jobs.find(j => j.status === 'active' || j.status === 'inactive');
            if (!job || !job.work_timezone) return;

            const currentDate = moment.tz(job.work_timezone);

            findTimesheets(job.id, undefined, undefined, timesheets => {
                const pendingTimesheet = (timesheets || []).find(t => t.status === TIMESHEET_STATUS.PENDING);

                if (pendingTimesheet) {
                    this.setState({ ...this.state, date: moment.tz(pendingTimesheet.period_ending, job.work_timezone), timesheet: pendingTimesheet });
                    return;
                }

                const weekRange = getWeekRange(moment.tz(job.work_timezone), job.work_timezone);

                const currentWeekTimesheet = (timesheets || []).find(t => isSameDay(t.period_ending, weekRange.to));
                if (currentWeekTimesheet) {
                    this.setState({ ...this.state, date: moment.tz(currentWeekTimesheet.period_ending, job.work_timezone), timesheet: currentWeekTimesheet });
                    return;
                }

                if (job.status === 'active' && !currentWeekTimesheet) {
                    createTimesheet(job.id, weekRange.to, this.initialize, () =>
                        this.setState({ ...this.state, date: currentDate, pendingTimesheetExists: true })
                    );
                    return;
                }
            });
        });
    }

    componentDidMount() {
        this.initialize();
    }

    renderMessage(message, heading = null) {
        return (
            <div className="row">
                <div className="col-xs-12">
                    {heading && <FormattedMessage {...heading} tagName={'h4'} />}
                    <FormattedMessage {...message} />
                </div>
            </div>
        );
    }

    renderContactSupportError() {
        const message = { id: 'time.pendingTimesheetExists', defaultMessage: 'Previous period timesheet is still being processed, please contact support.' };
        return this.renderMessage(message, messages.ohNo);
    }

    getTabs() {
        const { date, timesheet } = this.state;
        const { job } = this.props;
        const timesheetsLabel = messages.priorPeriods;
        const timeKeepingLabel = messages.currentPeriod;

        const currentWeekTab =
            job.status === 'active'
                ? [
                      {
                          title: <FormattedMessage {...timeKeepingLabel} />,
                          content: date ? <WorkWeek date={date} job={job} timesheet={timesheet} /> : null
                      }
                  ]
                : [];

        const priorWeeksTab = [
            {
                title: <FormattedMessage {...timesheetsLabel} />,
                content: (
                    <div className="col-xs-12 timesheet-list">
                        <TimesheetsList job={job} />
                    </div>
                )
            }
        ];

        const tabs = [...currentWeekTab, ...priorWeeksTab];

        return tabs;
    }

    renderNoDataCard() {
        return (
            <NoDataCard pageTitleMessage={messages.timekeeping}>
                <NoDataCard.Image />
                <NoDataCard.Body title={messages.timesheetUnderReview} message={messages.timeOnceAccepted}>
                    <button className="btn btn-success" onClick={() => history.push('/dashboard')}>
                        <FormattedMessage {...messages.seeAssignmentStatus} />
                    </button>
                </NoDataCard.Body>
            </NoDataCard>
        );
    }

    render() {
        const { date, timesheet, pendingTimesheetExists } = this.state;
        const { jobs, job, timesheets, dashboard } = this.props;
        if (pendingTimesheetExists) return this.renderContactSupportError();
        if (!jobs) return null;

        if (jobs.length === 0 || !job) return this.renderNoDataCard();
        if (!date || !timesheets || timesheets.length === 0) return null;
        const defaultTab = (history.location.state || { defaultTab: 0 }).defaultTab;

        return dashboard ? (
            <WorkWeek date={date} job={job} timesheet={timesheet} dashboard={true} />
        ) : (
            <React.Fragment>
                <Tabs
                    items={this.getTabs()}
                    defaultTab={defaultTab}
                    pageWide
                    title={<FormattedMessage {...(job.pay_type === 'h' ? messages.timekeeping : messages.invoicing)} />}
                    isPageTitle={true}
                />
            </React.Fragment>
        );
    }
}

function getJob(jobsList) {
    if (!jobsList) return undefined;

    const activeJob = jobsList.find(j => j.status === 'active');
    if (activeJob) return activeJob;

    const inactiveJob = jobsList.find(j => j.status === 'inactive');
    if (inactiveJob) return inactiveJob;
    return undefined;
}

const mapStateToProps = state => {
    return {
        role: state.identity.role,
        details: state.identity.details,
        job: getJob(state.jobs.list),
        timesheets: state.timekeeping.rangeTimesheets,
        jobs: state.jobs.list
    };
};

const mapDispatchToProps = dispatch =>
    bindActionCreators(
        {
            getJobs,
            findTimesheets,
            createTimesheet
        },
        dispatch
    );

export default connect(mapStateToProps, mapDispatchToProps)(ContractorTimeKeeping);



// WEBPACK FOOTER //
// ./src/pages/timekeeping/tenants/contractor/index.jsx